import BaseAPI from './base/base-api';

class ServiceRegisDecAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'DeclareAPI';
	controllerName = 'serviceregis';
}

export default new ServiceRegisDecAPI();
